import {
  Col,
  ENotificationType,
  Row,
  TRtkErrorType,
  useShowToastNotification,
  useTranslation,
} from '@packages/utils';
import EditableInput from 'components/Base/EditableFields/EditableInput';
import { InplaceEditLabels } from 'components/Base/EditableFields/components/InplaceEditLabel';
import { useUpdatePeopleLastNameMutation } from 'redux/apiSlice/people.slice';
import { EIconNames } from 'components/Base/Icon';
import { TLastNameProps } from './LastName.types';

const LastName = ({ userId, data }: TLastNameProps) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.people.details.details-tab.main-contact.last-name',
  });
  const { showToastNotification } = useShowToastNotification();
  const [editLastName, { isLoading, isError }] =
    useUpdatePeopleLastNameMutation();

  const onEdit = async (value: string) => {
    try {
      await editLastName({
        userId,
        lastName: value,
      }).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
    } catch (e) {
      showToastNotification({
        message: (e as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Row align="middle" wrap={false} className="w-100 mb-1">
      <Col>
        <InplaceEditLabels
          label={t('INPLACE_EDIT_LABEL')}
          icon={EIconNames.PROFILE}
        />
      </Col>
      <Col flex="auto">
        <EditableInput
          onEdit={onEdit}
          title={data.value}
          isError={isError}
          isLoading={isLoading}
          fitContent={false}
          validateTrigger="onSubmit"
          readonly={data?.allowedOperations.readonly}
          canRemove={data?.allowedOperations.canRemove}
          emptyText={t('EMPTY_TEXT')}
          placeholder={t('PLACEHOLDER')}
          backIcon
        />
      </Col>
    </Row>
  );
};

export default LastName;
